var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9984 19.198C20.9187 19.2534 20.8364 19.3058 20.7517 19.3552L18 20.9579L7.20864 14.6726V9.32108L17.9946 3.03901L20.7517 4.64482C20.8488 4.70132 20.9426 4.76192 21.0331 4.82632L13.3255 9.30737V9.2964L10.2365 11.1033V12.941L13.3255 14.744V12.9188L22.5732 7.53269C22.5822 7.63804 22.5868 7.7443 22.5868 7.85121V11.0933L16.4288 14.6977L16.4288 16.5489L20.9984 19.198Z",
    fill: "url(#paint0_radial_10141_38344)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9056 1.23987L13.6285 0.496029C12.4929 -0.165344 11.0939 -0.165344 9.95834 0.496029L2.83507 4.64482C1.69952 5.3062 1 6.52846 1 7.8512V16.1488C1 17.4715 1.69952 18.6938 2.83506 19.3552L9.95834 23.504C11.0939 24.1653 12.4929 24.1653 13.6285 23.504L14.911 22.757L4.11961 16.4718L4.11961 7.52429L4.12384 7.52674L4.11961 7.52194L14.9056 1.23987Z",
    fill: "url(#paint1_radial_10141_38344)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10141_38344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.45724 21.9477) rotate(-54.6998) scale(21.8989 35.2658)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0965F1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_10141_38344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.45724 21.9477) rotate(-54.6998) scale(21.8989 35.2658)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0965F1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.9b9a4bc71ebb40e77d701fb23c3fe4bb.svg";
export { ForwardRef as ReactComponent };